import _ from 'lodash';
import { MAX_NUMBER_OF_PACKAGE } from '@/constants/PackageData';
/**
 * Use Case: Modify PackageData base on key value
 * @param data - any, PackageData
 * @param packageKey - string, possible values: free, plus,
 * @param moduleKey - string, possible values: landing, user,
 */

export const modifyPackageData = (data: any, packageKey: any, moduleKey: string) => {
  let [starter] = data.filter((item: any) => item.nameKey === 'starter');
  let [pro] = data.filter((item: any) => item.nameKey === 'pro');
  let [enterprise] = data.filter((item: any) => item.nameKey === 'enterprise');

  const showCurrentPackage = { showHeader: true, showCurrentPackageHeader: true };
  const showSelectButton = { showSelectButton: true, showButton: true };
  const showPopularHeader = { showHeader: true, showPopularHeader: true };
  const updateEnterprise = { ...showSelectButton, ...showPopularHeader };

  // data for landing package
  if (moduleKey === 'landing') {
    const updateLandingPackage = {
      showHeader: true,
      showLandingHeader: true,
      showButton: true,
      buttonStyle: '@primary-color',
      buttonTextStyle: 'white',
    };

    pro = { ...pro, ...updateLandingPackage };
  }

  if (moduleKey === 'user') {
    if (packageKey === 'plus') {
      //if user's current package is pro and there is a data length of 3, remove starter package from array
      data.length === MAX_NUMBER_OF_PACKAGE && data.splice(0, 1);

      pro = { ...pro, ...showCurrentPackage };
    } else {
      // current package is free
      starter = { ...starter, ...showCurrentPackage };
      pro = { ...pro, ...showSelectButton };
    }

    enterprise = { ...enterprise, ...updateEnterprise };
  }

  // put all updated package data in an array
  // replacing old package data with updated data
  const updatedPackages = [starter, pro, enterprise];

  _.forEach(updatedPackages, value =>
    data.splice(
      _.findIndex(data, (obj: any) => obj.nameKey === value.nameKey),
      1,
      value,
    ),
  );

  return data;
};
